<template>
  <div>
    <img src="../../assets/logo/404.png" alt="" />
  </div>
</template>

<script>
export default {
  mounted() {
  }
}
</script>
